import ModalAlerta from "../modal";
import Ajudinha from "../ajudinha";
import DecimalMonetario from "../decimal";
import React, { useEffect, useState } from "react";
import { Modal, Form, Button, Row, Col, Accordion, Card, Alert } from "react-bootstrap";
import { TipoFormulario } from "../../services/constantes";
import { FaMoneyBillWave, FaCalendarAlt, FaChevronDown, FaChevronUp, FaSave, FaCheckCircle } from "react-icons/fa";
import { toast } from "react-toastify";
import { formatarParaReais, dateToInputValue } from "../../services/utilitarios";
import asaas from "../../assets/asaas.png"
import { confirm } from "../confirm";
import api from "../../services/api";
import { obterIdTenent } from "../../services/seguranca";
import { useAppSelector } from "../../store/hooks";
import { Banco } from "../../services/tipos";

const modalStyles = `
    .modern-modal .modal-content {
        border: none;
        box-shadow: 0 4px 20px rgba(0,0,0,0.15);
        border-radius: 8px;
    }
    .modern-modal .modal-header {
        background-color: #1f467e;
        border-radius: 8px 8px 0 0 !important;
    }
    .modern-modal .btn-primary {
        background-color: #1f467e;
        border-color: #1f467e;
    }
    .modern-modal .btn-primary:hover {
        background-color: #173a6b;
        border-color: #173a6b;
    }
    .modern-modal .btn-success {
        background-color: #28a745;
        border-color: #28a745;
    }
    .modern-modal .btn-success:hover {
        background-color: #218838;
        border-color: #1e7e34;
    }
    .modern-modal .form-control-sm, 
    .modern-modal .form-select-sm {
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
    }
    .modern-modal .form-check-input {
        margin-top: 0.2em;
    }
    .cursor-pointer {
        cursor: pointer;
    }
    .modal-md-custom {
        max-width: 650px;
    }
    .asaas-integration-badge {
        background: linear-gradient(135deg, #00b894 0%, #00a085 100%);
        color: white;
        padding: 4px 8px;
        border-radius: 4px;
        font-size: 0.75rem;
        font-weight: bold;
        display: inline-flex;
        align-items: center;
        gap: 4px;
    }
    .obs-text {
        color: #6c757d;
        font-style: italic;
        font-size: 0.85rem;
        margin-top: 4px;
        padding-left: 8px;
        border-left: 2px solid #dee2e6;
    }
`;

interface ModalConfirmacaoPagamentoProps {
    show: boolean;
    dataInicial: string;
    onClose: () => void;
    valorInicial: number;
    motivoPagamento: string;
    onConfirm: (dados: {
        valor: number;
        gerarPendencia: boolean;
        dataPagamento: string;
        dataVencimentoPendencia: string | null;
        motivoPagamento: string;
        motivoPendencia: string;
        valorPendencia: number;
        marcarPagamentoOrigemComoPago: boolean;
        alterarVencimentoOriginal: boolean;
        novaDataVencimentoOriginal: string | null;
        confirmarPagamento: boolean;
        naoContabilizarJuros: boolean;
        naoContabilizarMulta: boolean;
        idBanco?: string | null;
    }) => Promise<void>;
    onSubmitting?: (isSubmitting: boolean) => void;
    integradoAsaas?: boolean;
    statusPagamento?: number;
    idBancoInicial?: string | null;
}

const ModalConfirmacaoPagamento: React.FC<ModalConfirmacaoPagamentoProps> = ({
    show,
    onClose,
    onConfirm,
    onSubmitting,
    dataInicial,
    valorInicial,
    motivoPagamento,
    integradoAsaas = false,
    statusPagamento = 0,
    idBancoInicial = null,
}) => {
    const token = useAppSelector(state => state.token);
    const [bancos, setBancos] = useState<Banco[]>([]);
    const [idBanco, setIdBanco] = useState<string | undefined>(undefined);
    const [valor, setValor] = useState(valorInicial);
    const [message, setMessage] = useState<string[]>([]);
    const [dataPagamento, setDataPagamento] = useState(dataInicial);
    const [dataVencimentoPendencia, setDataVencimentoPendencia] = useState(dataInicial);
    const [gerarPendencia, setGerarPendencia] = useState(false);
    const [showAlerta, setShowAlerta] = useState<boolean>(false);
    const [motivo, setMotivo] = useState<string>(motivoPagamento);
    const [motivoPendencia, setMotivoPendencia] = useState<string>("");
    const [valorPendencia, setValorPendencia] = useState<number>(0);
    const [pagamentoOrigemPago, setPagamentoOrigemPago] = useState<boolean>(false);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const [alterarVencimentoOriginal, setAlterarVencimentoOriginal] = useState<boolean>(false);
    const [novaDataVencimentoOriginal, setNovaDataVencimentoOriginal] = useState<string>(dataInicial);
    const [accordionOpen, setAccordionOpen] = useState(false);
    const [acaoSelecionada, setAcaoSelecionada] = useState<'salvar' | 'confirmar' | null>(null);
    const [naoContabilizarJuros, setNaoContabilizarJuros] = useState(false);
    const [naoContabilizarMulta, setNaoContabilizarMulta] = useState(false);

    const isPago = statusPagamento === 1;

    const handleValorChange = (nome: string, value: number) => {
        setValor(value);
        if (gerarPendencia && value < valorInicial) {
            setValorPendencia(valorInicial - value);
        }
    };

    const handleValorPendenciaChange = (nome: string, value: number) => {
        setValorPendencia(value);
    };

    useEffect(() => {
        if (show) {
            setValor(valorInicial);
            setGerarPendencia(false);
            setDataPagamento(dataInicial);
            setDataVencimentoPendencia(dataInicial);
            setMotivo(motivoPagamento || "");
            setMotivoPendencia("");
            setValorPendencia(0);
            setPagamentoOrigemPago(false);
            setAlterarVencimentoOriginal(false);
            setNovaDataVencimentoOriginal(dataInicial);
            setIsSubmitting(false);
            setAccordionOpen(false);
            setAcaoSelecionada(null);
            setNaoContabilizarJuros(false);
            setNaoContabilizarMulta(false);
            setIdBanco(idBancoInicial ?? undefined);
        }
    }, [show, valorInicial, motivoPagamento, dataInicial, idBancoInicial]);

    useEffect(() => {
        if (!show) return;
        api.get(`/bancoPorEmpresa/${obterIdTenent(token)}?apenasAtivos=true`)
            .then(r => setBancos(r.data))
            .catch(() => setBancos([]));
    }, [show, token]);

    const handleCheckboxChange = () => {
        const novoValor = !gerarPendencia;
        setGerarPendencia(novoValor);
        if (novoValor) {
            const pendenciaCalculada = Math.max(0, valorInicial - valor);
            setValorPendencia(pendenciaCalculada);
        } else {
            setValorPendencia(0);
        }
    };

    const handleAlterarVencimentoChange = () => {
        setAlterarVencimentoOriginal(!alterarVencimentoOriginal);
    };

    const handleNovaDataVencimentoChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setNovaDataVencimentoOriginal(event.target.value);
    };

    const handleMarcarPagamentoPagoChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPagamentoOrigemPago(event.target.checked);
    };

    const handleDataPagamentoChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setDataPagamento(event.target.value);
    };

    const handleDataVencimentoPendenciaChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setDataVencimentoPendencia(event.target.value);
    };

    const handleMotivoChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setMotivo(event.target.value.toUpperCase());
    };

    const handleMotivoPendenciaChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setMotivoPendencia(event.target.value.toUpperCase());
    };

    const validarData = (confirmar: boolean): boolean => {
        if (!dataPagamento) {
            setMessage(['Por favor, informe a data do pagamento!']);
            setShowAlerta(true);
            return false;
        }

        if (alterarVencimentoOriginal && !novaDataVencimentoOriginal) {
            setMessage(['Por favor, informe a nova data de vencimento!']);
            setShowAlerta(true);
            return false;
        }

        if (gerarPendencia && valorPendencia <= 0) {
            setMessage(['O valor da pendência deve ser maior que zero!']);
            setShowAlerta(true);
            return false;
        }

        if (gerarPendencia && !dataVencimentoPendencia) {
            setMessage(['Por favor, informe a data de vencimento da pendência!']);
            setShowAlerta(true);
            return false;
        }

        if (gerarPendencia && !motivoPendencia) {
            setMessage(['Por favor, informe o motivo da pendência!']);
            setShowAlerta(true);
            return false;
        }

        if (confirmar && !dataPagamento) {
            setMessage(['Para confirmar o pagamento, é necessário informar a data de pagamento!']);
            setShowAlerta(true);
            return false;
        }

        // Recebimento é fato consumado: data futura não faz sentido sempre que esta data vira a data
        // de recebimento (confirmar, corrigir um pagamento já quitado ou marcar a origem como paga).
        if ((confirmar || isPago || pagamentoOrigemPago) && dataPagamento > dateToInputValue(new Date())) {
            setMessage(['A data do pagamento não pode ser posterior a hoje.']);
            setShowAlerta(true);
            return false;
        }

        return true;
    };

    const handleAcao = async (acao: 'salvar' | 'confirmar') => {
        if (isSubmitting) return;

        if (integradoAsaas && acao === 'confirmar') {
            if (!await confirm("Este pagamento é gerenciado pelo Asaas.\nAo confirmar, a fatura será marcada como recebida em dinheiro no Asaas. Deseja continuar?")) {
                return;
            }
        }

        if (!validarData(acao === 'confirmar')) return;

        await executarAcao(acao);
    };

    const executarAcao = async (acao: 'salvar' | 'confirmar') => {
        try {
            setIsSubmitting(true);
            setAcaoSelecionada(acao);
            if (onSubmitting) onSubmitting(true);

            await onConfirm({
                valor,
                gerarPendencia,
                dataPagamento,
                dataVencimentoPendencia: gerarPendencia ? dataVencimentoPendencia : null,
                motivoPagamento: motivo,
                motivoPendencia,
                valorPendencia,
                marcarPagamentoOrigemComoPago: acao === 'confirmar' ? true : pagamentoOrigemPago,
                alterarVencimentoOriginal,
                novaDataVencimentoOriginal: alterarVencimentoOriginal ? novaDataVencimentoOriginal : null,
                confirmarPagamento: acao === 'confirmar',
                naoContabilizarJuros,
                naoContabilizarMulta,
                idBanco: idBanco || null,
            });

            onClose();
        } catch (error) {
            toast.error(`Erro ao ${acao === 'confirmar' ? 'confirmar' : 'salvar'} pagamento`);
        } finally {
            setIsSubmitting(false);
            setAcaoSelecionada(null);
            if (onSubmitting) onSubmitting(false);
        }
    };

    const handleConfirmarAlerta = () => {
        setShowAlerta(false);
        if (acaoSelecionada) {
            executarAcao(acaoSelecionada);
        }
    };

    const handleCancelarAlerta = () => {
        setShowAlerta(false);
        setAcaoSelecionada(null);
    };

    return (
        <>
            <style>{modalStyles}</style>

            <Modal show={show} onHide={onClose} centered className="modern-modal" size="lg">
                <Modal.Header className="text-white border-0">
                    <Modal.Title className="fs-5 d-flex align-items-center gap-2">
                        {integradoAsaas ? 'Edição de Pagamento' : isPago ? 'Edição de Pagamento' : 'Edição e Confirmação de Pagamento'}
                        {integradoAsaas && (
                            <span className="asaas-integration-badge">
                                <img
                                    src={asaas}
                                    alt="Asaas"
                                    style={{ width: 16, height: 16 }}
                                />
                                Integrado com Asaas
                            </span>
                        )}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-3">
                    {integradoAsaas && (
                        <Alert variant="warning" className="py-2">
                            <small>
                                <strong>Atenção:</strong> Este pagamento está integrado com o Asaas.
                                Alterações aqui serão refletidas no sistema de cobrança.
                            </small>
                        </Alert>
                    )}

                    {isPago && (
                        <Alert variant="info" className="py-2">
                            <small>
                                <strong>Informação:</strong> Este pagamento já está confirmado.
                                Você pode editá-lo, mas não é possível confirmá-lo novamente.
                            </small>
                        </Alert>
                    )}

                    <Form>
                        <Row className="g-3">
                            <Col md={6} data-tour="campo-valor-recebido">
                                <Form.Group controlId="campoValor">
                                    <Form.Label className="fw-medium">
                                        Valor {isPago ? 'Pago' : 'Recebido'}
                                        <Ajudinha
                                            texto="Digite o valor que está sendo recebido agora. Se for menor que o valor total, você pode gerar uma pendência para o restante."
                                        />
                                    </Form.Label>
                                    <DecimalMonetario
                                        campo={{
                                            nome: "valor",
                                            tipo: "monetario",
                                            required: true,
                                            modo: TipoFormulario.tpEdicao,
                                        }}
                                        getFieldValue={() => valor}
                                        handleInputChange={handleValorChange}
                                        largura="100%"
                                        valorInicial={valorInicial}
                                    />
                                    <div className="text-muted small mt-1">
                                        Valor original: R$ {valorInicial.toFixed(2)}
                                        {valor < valorInicial && (
                                            <span className="ms-2">
                                                <strong>(Restante: {formatarParaReais(valorInicial - valor)})</strong>
                                            </span>
                                        )}
                                        <br />
                                        <span>
                                            Clique em <strong>"Opções avançadas"</strong> para gerar uma pendência
                                        </span>
                                    </div>
                                </Form.Group>
                            </Col>

                            <Col md={6}>
                                <Form.Group controlId="dataPagamento">
                                    <Form.Label className="fw-medium">
                                        Data {isPago ? 'do Pagamento' : 'que recebeu o Pagamento'}
                                        <Ajudinha
                                            texto="Selecione a data em que este pagamento foi recebido."
                                        />
                                    </Form.Label>
                                    <Form.Control
                                        type="date"
                                        value={dataPagamento}
                                        onChange={handleDataPagamentoChange}
                                        max={dateToInputValue(new Date())}
                                        className="form-control-sm"
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={12}>
                                <Form.Group controlId="motivoPagamento">
                                    <Form.Label className="fw-medium">
                                        Motivo/Descrição do Pagamento
                                        <Ajudinha
                                            texto="Descreva brevemente o motivo deste pagamento (ex: 'Pagamento parcial', 'Acerto de conta', etc)."
                                        />
                                    </Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={2}
                                        placeholder="Ex: Pagamento parcial com desconto..."
                                        value={motivo}
                                        onChange={handleMotivoChange}
                                        className="form-control-sm"
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <div className="mt-3">
                            <Card className="border-0">
                                <Card.Header
                                    className="bg-light cursor-pointer d-flex justify-content-between align-items-center p-2"
                                    onClick={() => setAccordionOpen(!accordionOpen)}
                                    data-tour="opcoes-avancadas"
                                >
                                    <div className="d-flex align-items-center">
                                        <FaCalendarAlt className="me-2" />
                                        <span className="fw-medium">Opções Avançadas</span>
                                    </div>
                                    {accordionOpen ? <FaChevronUp /> : <FaChevronDown />}
                                </Card.Header>

                                {accordionOpen && (
                                    <Card.Body className="p-2">
                                        <Form.Group controlId="alterarVencimento" className="mb-2 mt-2">
                                            <Form.Check
                                                type="checkbox"
                                                label="Marque para alterar a data do vencimento original"
                                                checked={alterarVencimentoOriginal}
                                                onChange={handleAlterarVencimentoChange}
                                                className="form-check-sm"
                                            />
                                            {alterarVencimentoOriginal && (
                                                <div className="mt-2 ms-4">
                                                    <Form.Label className="small">Nova data de vencimento do pagamento original:</Form.Label>
                                                    <Form.Control
                                                        type="date"
                                                        value={novaDataVencimentoOriginal}
                                                        onChange={handleNovaDataVencimentoChange}
                                                        className="form-control-sm"
                                                    />
                                                </div>
                                            )}
                                        </Form.Group>

                                        <Form.Group controlId="gerarPendencia" className="mb-2" data-tour="gerar-pendencia">
                                            <Form.Check
                                                type="checkbox"
                                                label="Marque para gerar uma pendência referente a valor não recebido ou juros"
                                                checked={gerarPendencia}
                                                onChange={handleCheckboxChange}
                                                className="form-check-sm"
                                            />
                                            {gerarPendencia && (
                                                <div className="mt-2 p-2 bg-light rounded">
                                                    <Row className="g-2">
                                                        <Col md={6}>
                                                            <Form.Group controlId="campoValorASerGerado">
                                                                <Form.Label className="small">Valor da Pendência:</Form.Label>
                                                                <DecimalMonetario
                                                                    campo={{
                                                                        nome: "valorPendencia",
                                                                        tipo: "monetario",
                                                                        required: true,
                                                                        modo: TipoFormulario.tpEdicao,
                                                                    }}
                                                                    getFieldValue={() => valorPendencia}
                                                                    handleInputChange={handleValorPendenciaChange}
                                                                    largura="100%"
                                                                    valorInicial={valorPendencia}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col md={6}>
                                                            <Form.Group controlId="dataVencimentoPendencia">
                                                                <Form.Label className="small">Data de Vencimento da Pendência:</Form.Label>
                                                                <Form.Control
                                                                    type="date"
                                                                    value={dataVencimentoPendencia}
                                                                    onChange={handleDataVencimentoPendenciaChange}
                                                                    className="form-control-sm"
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col md={12}>
                                                            <Form.Group controlId="motivoPendencia">
                                                                <Form.Label className="small">
                                                                    Motivo da Pendência: <span className="text-danger">*</span>
                                                                </Form.Label>
                                                                <Form.Control
                                                                    as="textarea"
                                                                    rows={2}
                                                                    placeholder="Ex: Restante do pagamento com juros..."
                                                                    value={motivoPendencia}
                                                                    onChange={handleMotivoPendenciaChange}
                                                                    className="form-control-sm"
                                                                    required={gerarPendencia}
                                                                />
                                                            </Form.Group>
                                                        </Col>

                                                    </Row>
                                                    {!integradoAsaas && <Form.Group controlId="marcarPago" className="mt-2">
                                                        <Form.Check
                                                            type="checkbox"
                                                            label="Marque se deseja definir o pagamento original como Pago/Recebido"
                                                            checked={pagamentoOrigemPago}
                                                            onChange={handleMarcarPagamentoPagoChange}
                                                            className="form-check-sm"
                                                        />
                                                    </Form.Group>}
                                                </div>
                                            )}
                                        </Form.Group>

                                        <div className="d-flex gap-3 mt-2 pt-2 border-top">
                                            <Form.Check
                                                type="checkbox"
                                                id="naoContabilizarJuros"
                                                label="Não contabilizar Juros neste pagamento"
                                                checked={naoContabilizarJuros}
                                                onChange={(e) => setNaoContabilizarJuros(e.target.checked)}
                                                className="form-check-sm"
                                            />
                                            <Form.Check
                                                type="checkbox"
                                                id="naoContabilizarMulta"
                                                label="Não contabilizar Multa neste pagamento"
                                                checked={naoContabilizarMulta}
                                                onChange={(e) => setNaoContabilizarMulta(e.target.checked)}
                                                className="form-check-sm"
                                            />
                                        </div>

                                        <Form.Group className="mb-2 mt-3" controlId="campoBanco">
                                            <Form.Label className="small fw-medium">Banco (opcional)</Form.Label>
                                            <Form.Control
                                                as="select"
                                                size="sm"
                                                value={idBanco ?? ''}
                                                onChange={(e: React.ChangeEvent<HTMLSelectElement>) => setIdBanco(e.target.value || undefined)}
                                            >
                                                <option value="">— Sem banco —</option>
                                                {bancos.map(b => (
                                                    <option key={b.id} value={b.id}>{b.apelido}</option>
                                                ))}
                                            </Form.Control>
                                            <Form.Text className="text-muted">
                                                Informe o banco onde este pagamento foi/será recebido (apenas para conciliação).
                                            </Form.Text>
                                        </Form.Group>
                                    </Card.Body>
                                )}
                            </Card>
                        </div>
                    </Form>
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-between border-top-0 pt-0">
                    <Button
                        variant="outline-secondary"
                        onClick={onClose}
                        disabled={isSubmitting}
                        size="sm"
                    >
                        Cancelar
                    </Button>
                    <div className="d-flex gap-2">
                        <Button
                            variant="primary"
                            onClick={() => handleAcao('salvar')}
                            disabled={isSubmitting}
                            className="d-flex align-items-center"
                            size="sm"
                        >
                            {isSubmitting && acaoSelecionada === 'salvar' ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                    Salvando...
                                </>
                            ) : (
                                <>
                                    <FaSave className="me-2" />
                                    {gerarPendencia ? 'Salvar edição e gerar pendência' : 'Salvar Edição'}
                                </>
                            )}
                        </Button>

                        {!isPago && (
                            <Button
                                data-tour="btn-confirmar-pagamento"
                                variant="success"
                                onClick={() => handleAcao('confirmar')}
                                disabled={isSubmitting}
                                className="d-flex align-items-center"
                                size="sm"
                            >
                                {isSubmitting && acaoSelecionada === 'confirmar' ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                        Confirmando...
                                    </>
                                ) : (
                                    <>
                                        <FaCheckCircle className="me-2" />
                                        {gerarPendencia ? 'Confirmar pagamento e Gerar pendência' : 'Confirmar Pagamento'}
                                    </>
                                )}
                            </Button>
                        )}
                    </div>
                </Modal.Footer>
            </Modal>

            <ModalAlerta
                message={message}
                show={showAlerta}
                onHide={handleCancelarAlerta}
                ehDeSimNao={integradoAsaas && acaoSelecionada === 'confirmar'}
                onSim={handleConfirmarAlerta}
                onNao={handleCancelarAlerta}
            />
        </>
    );
};

export default ModalConfirmacaoPagamento;